import AiAgentsMenu from './AiAgentsMenu';
import { Tooltip } from '@sweep-io/sweep-design';
import { ButtonBase } from '@mui/material';
import { AiAgent } from './aiAgentsConsts';
import usePopover from '../../hooks/usePopover';
import useAgentsChats from './useAgentsChats';
import { useFunnelMapPage } from '../pages/funnel-map-flow/useFunnelMapPage';
import { ReactNode } from 'react';
import { useFeatureToggle } from '../../feature-flags/useFeatureToggle';

//This component should be used only in the funnel editor
const AgentsButtonAndMenu = ({ aiAgents, button }: { aiAgents: AiAgent[]; button: ReactNode }) => {
  const { openPopover, closePopover, isPopoverOpen, anchorRef, anchorElement } = usePopover();
  const { setAgentClickHandler } = useAgentsChats();
  const { onAiAgentCenterClick } = useFunnelMapPage(); //open the Agent Center in the Funnel Editor
  const { orgMigrationDemo } = useFeatureToggle();

  const onAgentClick = (agent: AiAgent) => {
    closePopover();
    setAgentClickHandler({ agent });
    onAiAgentCenterClick();
  };
  const hasAgents = aiAgents.length > 0;

  if (!hasAgents) return null;

  return (
    <>
      <Tooltip title="AI Agent activated" placement="top">
        <ButtonBase
          ref={anchorRef}
          onClick={(e) => {
            e.stopPropagation();
            if (orgMigrationDemo) {
              window.open(
                '/org-migration/selected-processes?process=Global_Service_Case_Support_Process',
                '_blank',
              );
              return;
            }
            if (aiAgents.length === 1) {
              onAgentClick(aiAgents[0]);
              return;
            }
            openPopover();
          }}
        >
          {button}
        </ButtonBase>
      </Tooltip>
      <AiAgentsMenu
        isOpen={isPopoverOpen}
        aiAgents={aiAgents}
        anchorElement={anchorElement}
        closeMenu={closePopover}
        onAgentClick={onAgentClick}
      />
    </>
  );
};

export default AgentsButtonAndMenu;
